import './App.scss'
import '../i18n'
import React, {Suspense} from 'react'
import {AppErrorBoundary} from 'components/ErrorBoundary'
import AppMain from './AppMain'
import {AppProvider} from './AppContext'

import Loader from 'components/Loader'
import {PlatformContext} from 'components/PlatformContext'
import {Provider} from 'react-redux'
import ThemeProvider from '../stitches/ThemeProvider/ThemeProvider'
import ninchatClient from '../api/NinchatClient'
import {store} from '../store'
import {t} from 'i18next'

window.addEventListener('beforeunload', () => ninchatClient.close())

const App = (): React.ReactElement => (
    <AppErrorBoundary fallbackElement={<Loader label={t('Something went wrong')} />}>
        <PlatformContext.Provider value='web'>
            <AppProvider>
                <Provider store={store}>
                    <ThemeProvider>
                        <Suspense fallback={<Loader />}>
                            <AppMain />
                        </Suspense>
                    </ThemeProvider>
                </Provider>
            </AppProvider>
        </PlatformContext.Provider>
    </AppErrorBoundary>
)

export default App
